const caseTypes = {
  GET_EXPORT_DATA_REQUEST: "GET_EXPORT_DATA_REQUEST",
  GET_EXPORT_DATA_SUCCESS: "GET_EXPORT_DATA_SUCCESS",
  GET_EXPORT_DATA_FAILED: "GET_EXPORT_DATA_FAILED",
  GET_DOCS3_REQUEST: "GET_DOCS3_REQUEST",
  GET_DOCS3_SUCCESS: "GET_DOCS3_SUCCESS",
  GET_DOCS3_FAILED: "GET_DOCS3_FAILED",
  POST_DOCS3_REQUEST: "POST_DOCS3_REQUEST",
  POST_DOCS3_SUCCESS: "POST_DOCS3_SUCCESS",
  POST_DOCS3_FAILED: "POST_DOCS3_FAILED",
  POST_MANY_CASES_REQUEST: "POST_MANY_CASES_REQUEST",
  POST_MANY_CASES_SUCCESS: "POST_MANY_CASES_SUCCESS",
  POST_MANY_CASES_FAILED: "POST_MANY_CASES_FAILED",
  GET_ALLDOCS3_REQUEST: "GET_ALLDOCS3_REQUEST",
  GET_ALLDOCS3_SUCCESS: "GET_ALLDOCS3_SUCCESS",
  GET_ALLDOCS3_FAILED: "GET_ALLDOCS3_FAILED",
  GET_REQUEST_GROUNDS_REQUEST: "GET_REQUEST_GROUNDS_REQUEST",
  GET_REQUEST_GROUNDS_SUCCESS: "GET_REQUEST_GROUNDS_SUCCESS",
  GET_REQUEST_GROUNDS_FAILED: "GET_REQUEST_GROUNDS_FAILED",
  GET_REQUEST_CLASSIFICATIONS_REQUEST: "GET_REQUEST_CLASSIFICATIONS_REQUEST",
  GET_REQUEST_CLASSIFICATIONS_SUCCESS: "GET_REQUEST_CLASSIFICATIONS_SUCCESS",
  GET_REQUEST_CLASSIFICATIONS_FAILED: "GET_REQUEST_CLASSIFICATIONS_FAILED",
  RESET_ALLDOCS3: "RESET_ALLDOCS3",
  RESET_REFINANCING_CASES: "RESET_REFINANCING_CASES",
}

export { caseTypes };
